import withLazyLoading from '../../hoc/withLazyLoading';
import EscalationLevel from '../../pages/EscalationLevel';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import { DATA_INPUT_RULES, INVENTORY_RULES, PLANT_RULES, SCADA_RULES, access, param } from '../../access';

const Plants = withLazyLoading(() => import('../../pages/Plants'));
const PlantConfiguration = withLazyLoading(() => import('../../pages/PlantConfiguration'));
const PlantVisualisationConfig = withLazyLoading(() => import('../../pages/PlantVisualisationConfig'));
const PlantVisualisationParent = withLazyLoading(() => import('../../pages/PlantVisualisationParent'));
const DataInputs = withLazyLoading(() => import('../../pages/DataInputs'));
const DataInputv2 = withLazyLoading(() => import('../../pages/DataInputv2'));
const DataInputConfigurationv2 = withLazyLoading(() => import('../../pages/DataInputConfigurationv2'));
const Sensors = withLazyLoading(() => import('../../pages/Sensors'));
const DataBreakForPlant = withLazyLoading(() => import('../.././components/DataBreak/DataBreakView'));
const DataBreakDetailsForSinglePlant = withLazyLoading( () => import('../.././components/DataBreak/DataBreakForPlantView'));
const ChemicalComposition = withLazyLoading(() => import('../../pages/ChemicalComposition'));

const plantRoutes = [
    {
        path: '/plants',
        handle: createCrumbHandle('Assets'),
        children: [
            {
                index: true,
                element: <Plants />,
                handle: access(PLANT_RULES.list),
            },
            {
                path: 'PlantConfig/:id',
                element: <PlantConfiguration />,
                handle: { ...createCrumbHandle('Asset Configuration'), ...access(PLANT_RULES.configure, param('id')) },
            },
            {
                path: 'sensors/:plantId',
                element: <Sensors />,
                handle: { ...createCrumbHandle('Sensors'), ...access(PLANT_RULES.sensors, param('plantId')) },
            },
            {
                path: 'DataInputConfigv2/:id',
                element: <DataInputConfigurationv2 />,
                handle: { ...createCrumbHandle('Data Input Configuration'), ...access(PLANT_RULES.dataInputConfig, param('id')) },
            },
            {
                path: 'DataInputs/:plantId',
                element: <DataInputs />,
                handle: { ...createCrumbHandle('Data Inputs'), ...access(DATA_INPUT_RULES.enter, param('plantId')) },
            },
            {
                path: 'escalation/:id',
                element: <EscalationLevel />,
                handle: { ...createCrumbHandle('Escalation Levels'), ...access(PLANT_RULES.escalation, param('id')) },
            },
        ]
    },
    {
        path: '/PlantVisualisationConfig/:plantId',
        element: <PlantVisualisationConfig />,
        handle: { ...createCrumbHandle('Asset Visualization Configuration'), ...access(SCADA_RULES.author, param('plantId')) },
    },
    {
        path: '/PlantVisualisation/:plantId',
        element: withPostHogTracker(<PlantVisualisationParent />),
        handle: { ...createCrumbHandle('Asset Visualization'), ...access(SCADA_RULES.view, param('plantId')) },
    },
    {
        path: '/data-inputv2/:plantId',
        element: <DataInputv2 />,
        handle: { ...createCrumbHandle('Data Inputs V2'), ...access(DATA_INPUT_RULES.enter, param('plantId')) },
    },
    {
        path: '/databreak',
        element: <DataBreakForPlant />,
        handle: { ...createCrumbHandle('Data Break'), ...access(PLANT_RULES.dataBreak) },
    },
    {
        path: '/databreakdetails/:assetId',
        element: <DataBreakDetailsForSinglePlant />,
        handle: { ...createCrumbHandle('Data Break Details'), ...access(PLANT_RULES.dataBreak) },
    },
    {
        path: '/ChemicalComposition/:plantId',
        element: <ChemicalComposition />,
        handle: { ...createCrumbHandle('Chemical Composition'), ...access(INVENTORY_RULES.useStock, param('plantId')) },
    },
];

export default plantRoutes;
